import './App.css';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import Home from './pages/Home';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import Live from './pages/Live';


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/:id" element={<Live />} />
          <Route path="room/:id" element={<Home/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;



